/**
 * <s-product-card> — color swatches on a product card.
 *
 * Markup inside: buttons[data-swatch] with data-variant-id, data-variant-url,
 * data-image and data-available; [data-card-primary] wraps the main <img>;
 * input[data-card-variant-input] and button[data-card-quick-add] belong to the
 * quick-add form. Picking a swatch shows that color's image, points the card
 * links at that variant, and makes quick add use it.
 */
class SProductCard extends HTMLElement {
  #ac;

  connectedCallback() {
    this.#ac = new AbortController();
    this.addEventListener('click', (event) => this.#onClick(event), { signal: this.#ac.signal });
  }

  disconnectedCallback() {
    this.#ac?.abort();
  }

  /** @param {MouseEvent} event */
  #onClick(event) {
    const swatch = event.target instanceof Element ? event.target.closest('[data-swatch]') : null;
    if (!(swatch instanceof HTMLButtonElement) || !this.contains(swatch)) return;
    event.preventDefault();
    this.#select(swatch);
  }

  /** @param {HTMLButtonElement} swatch */
  #select(swatch) {
    for (const button of this.querySelectorAll('[data-swatch]')) {
      button.setAttribute('aria-pressed', button === swatch ? 'true' : 'false');
    }

    const { variantId, variantUrl, image, available } = swatch.dataset;

    const input = this.querySelector('[data-card-variant-input]');
    if (input instanceof HTMLInputElement && variantId) input.value = variantId;

    const quickAdd = this.querySelector('[data-card-quick-add]');
    if (quickAdd instanceof HTMLButtonElement) quickAdd.disabled = available !== 'true';

    const img = this.querySelector('[data-card-primary] img');
    if (img instanceof HTMLImageElement && image) {
      img.removeAttribute('srcset');
      img.src = image;
    }

    if (variantUrl) {
      const target = new URL(variantUrl, window.location.href);
      for (const link of this.querySelectorAll('a[href]')) {
        if (!(link instanceof HTMLAnchorElement)) continue;
        if (new URL(link.href).pathname === target.pathname) link.href = target.href;
      }
    }
  }
}

customElements.define('s-product-card', SProductCard);
